import { Box, Typography } from '@mui/material';
import React, { memo, ReactElement, ReactNode } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import styles from './InfiniteScrollColumn.module.css';
type InfiniteScrollColumnProps = {
  render: (item: any, index: number) => React.ReactNode;
  height?: string; // Optional custom height
  dataVal: {
    records: any[];
    totalRecords?: number;
    totalSize?: number;
  };
  next: (offset: boolean) => Promise<void>;
  total?: number;
  loading?: boolean;
  children?: ReactElement | (() => JSX.Element);
  paddingBottom?: string;
  loaderComponent?: JSX.Element;
  more?: string;
  extraData?: number;
};
const InfiniteScrollColumn = memo(
  ({
    render,
    height = '65vh',
    dataVal,
    next,
    total,
    loading,
    children,
    paddingBottom,
    loaderComponent,
    extraData,
    more,
  }: InfiniteScrollColumnProps) => {
    const hasMore = total
      ? total > dataVal?.records?.length
      : dataVal?.totalRecords && dataVal?.totalRecords > dataVal?.records?.length;
    console.log(
      loading,
      'loading',
      more,
      'more',
      extraData,
      'extraData',
      dataVal?.records?.length,
      'records length',
      dataVal?.records?.length + (extraData ? extraData : 0),
    );
    return (
      <Box>
        {(dataVal?.records?.length > 0 || extraData) && (
          <InfiniteScroll
            dataLength={dataVal?.records?.length + (extraData ? extraData : 0)} // This is important field to render the next data
            next={async () => {
              console.log('next called');
              !loading && (await next(true));
            }}
            hasMore={more && !loading ? true : hasMore ? hasMore : false}
            loader={
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <h4></h4>
              </Box>
            }
            height={height}
            style={{
              display: 'flex',
              flexDirection: 'column',

              width: '100%',

              paddingBottom: paddingBottom ? paddingBottom : '40rem',
              // overflowY: 'auto',
            }}
            className={styles['scroll-gap']}
          >
            {children
              ? // If children is a function, invoke it
                typeof children === 'function'
                ? (children as () => ReactNode)()
                : children
              : dataVal?.records.map((val: any, index: number) => render(val, index))}
          </InfiniteScroll>
        )}
      </Box>
    );
  },
);

export default InfiniteScrollColumn;
